import './App.css';
import IndexPage from './pages/IndexPage'

function App() {
  return (
    <div className="App w-screen sm:w-3/5 lg:w-1/3 xl:1/4 2xl:1/5 mx-auto bg-gray-50 min-h-screen relative">
      <IndexPage/>
    </div>
  );
}

export default App;
